import axios from 'axios';
import { parse } from 'date-fns';

// const heroku = "https://qhse-prod.herokuapp.com";
// const digitalocean = "https://qhse-api-8e3su.ondigitalocean.app";
// export const BASEURL = process.env.NODE_ENV === "development" ? "http://localhost:8005" : digitalocean;
export const BASEURL = process.env.REACT_APP_BASEURL;

let headers = {
  'Content-Type': 'application/json',
  'x-client-signature': 'qhse-web',
};

const isTokenExpired = (token) => {
  const now = new Date();
  let expiredToken = token.expires_in;

  if (typeof (expiredToken) === 'string') expiredToken = parse(expiredToken, 'yyyy-MM-dd HH:mm:ss', new Date());

  expiredToken.setHours(expiredToken.getHours() - 7);
  
  return now > expiredToken;
}

const token = JSON.parse(localStorage.getItem("token"));
if (token) {
  headers = {
    'Content-Type': 'application/json',
    'x-client-signature': 'qhse-web',
    'x-qhse-token': token.access_token
  };
}

const client = axios.create({
  baseURL: BASEURL,
  headers: headers
});

client.defaults.timeout = 60000; //in ms so this is 60s timeout

client.interceptors.request.use((config) => {
  if (token) {
    if (isTokenExpired(token)) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.reload();
    } else {
      return config;
    }
  }

  return config;
});

export default client;

//no token api
export const openApi = axios.create({
  baseURL: BASEURL,
  headers: {
    'Content-Type': 'application/json',
    'x-client-signature': 'qhse-web',
  }
});

// export default axios.create({
//   baseURL: process.env.NODE_ENV === "development" ? "http://localhost:8005" : "https://qhse-prod.herokuapp.com",
//   headers: headers
// });
